import React, { useState, useEffect } from 'react';
import '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import { ConditionalWrapper } from '../../primitives/ConditionalWrapper/ConditionalWrapper.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import { Pin } from '../../primitives/Pin/Pin.es.js';
import { Dot, Badge as Badge$1, Content } from './styled.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const BadgeElement = (_a) => {
  var _b = _a, {
    content: contentProp,
    max = 99,
    icon: IconComponent,
    variant = "default",
    size = "md",
    isRounded = false,
    kind = "base",
    showZero = false,
    isDot = false,
    isPinned = false
  } = _b, props = __objRest(_b, [
    "content",
    "max",
    "icon",
    "variant",
    "size",
    "isRounded",
    "kind",
    "showZero",
    "isDot",
    "isPinned"
  ]);
  const [content, setContent] = useState(contentProp);
  useEffect(() => {
    switch (typeof contentProp) {
      case "number":
        setContent(contentProp > max ? `${max}+` : contentProp);
        break;
      default:
        setContent(contentProp);
        break;
    }
  }, [contentProp, max]);
  if (!showZero && typeof content === "number" && content <= 0) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null);
  }
  if (contentProp === "undefined" && !IconComponent || isDot) {
    return /* @__PURE__ */ React.createElement(Dot, {
      variant,
      kind,
      isPinned
    });
  }
  return /* @__PURE__ */ React.createElement(Badge$1, __spreadValues({
    variant,
    size,
    kind,
    isRounded,
    isPinned
  }, props), /* @__PURE__ */ React.createElement(ConditionalWrapper, {
    condition: content,
    wrapper: (children) => /* @__PURE__ */ React.createElement(Content, {
      size
    }, children)
  }, !!IconComponent && /* @__PURE__ */ React.createElement(IconComponent, {
    size: "xs"
  }), content));
};
const PinnedBadge = (_c) => {
  var _d = _c, { children, anchorShape = "square", pinPlacement = "top-right" } = _d, props = __objRest(_d, ["children", "anchorShape", "pinPlacement"]);
  const offset = {
    square: [0, 0],
    circle: ["14%", "14%"]
  };
  return /* @__PURE__ */ React.createElement(Pin, {
    pinOffset: offset[anchorShape],
    component: /* @__PURE__ */ React.createElement(BadgeElement, __spreadValues({
      isPinned: true
    }, props)),
    placement: pinPlacement
  }, children);
};
const Badge = (_e) => {
  var _f = _e, { children } = _f, props = __objRest(_f, ["children"]);
  return children ? /* @__PURE__ */ React.createElement(PinnedBadge, __spreadValues({}, props), children) : /* @__PURE__ */ React.createElement(BadgeElement, __spreadValues({}, props));
};

export { Badge };
//# sourceMappingURL=Badge.es.js.map
